/**
 * This file is auto-generated by protobufgen
 * Don't change manually
 */

import { MailPriceType as PoolMailPriceType } from "../pool/app";
import { TPlayground as PageTPlayground, TModule as PageTModule, TModuleType as PageTModuleType, TModuleHeader as PageTModuleHeader, Layout as PageLayout, Ui as PageUi, TProductElement as PageTProductElement } from "../page/admin";
import { Result as PageResult } from "../page/common";
import webapi from "../webapi";

export interface FrontMeta {
	catalog?: string;
	lang?: string;
	client?: string;
	priceSymbol?: string;
	userInfos?: UserInfos;
	mail?: boolean;
	mailPriceType?: PoolMailPriceType;
	pageId?: string;
}

export interface UserInfos {
	app_key?: string;
	app_secret?: string;
	sessionkey?: string;
	sid?: string;
	sign?: string;
	visit?: string;
	fav?: string;
	cust?: string;
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	userType?: number;
}

export interface GetFrontPlaygroundReq {
	slug?: string;
	version?: string;
	id?: string;
	meta?: FrontMeta;
}

export interface GetFrontPlaygroundResp {
	modules?: TFrontModule[];
	page?: PageTPlayground;
}

export interface GetFrontModulesReq {
	moduleId?: string[];
	meta?: FrontMeta;
}

export interface GetFrontModulesResp {
	mods?: {[key: string]: PageTModule};
}

export interface TFrontModule {
	id?: string;
	type?: PageTModuleType;
	header?: PageTModuleHeader;
	layout?: PageLayout;
	ui?: PageUi;
}

export interface GetFrontModulesBySlugAndTypeReq {
	slug: string;
	types: PageTModuleType[];
}

export interface TModuleGroup {
	mods?: PageTModule[];
}

export interface GetFrontModulesBySlugAndTypeResp {
	moduleGroups?: {[key: string]: TModuleGroup};
}

export interface GetProductsReq {
	poolId: string;
	/**
	 * @pattern ^\d+$
	 */
	limit?: string;
	/**
	 * @pattern ^\d+$
	 */
	offset?: string;
	meta?: FrontMeta;
	/**
	 * @pattern ^\d+$
	 */
	topGpids?: string[];
}

export interface GetProductsResp {
	products?: PageTProductElement[];
	hasNext?: boolean;
}

export interface GetSeoInfoReq {
	pageId: string;
}

export interface GetSeoInfoResp {
	seoKeyword?: string;
	seoDesc?: string;
	pageName?: string;
	multiTitle?: {[key: string]: string};
}

export interface GetFlashProductsReq {
	activeIds?: string[];
	poolIds?: string[];
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	limit?: number;
}

export interface GetFlashProductsResp {
	fs?: FlashProducts[];
}

export interface FlashProducts {
	products?: PageTProductElement[];
}

export interface GetPageInfoReq {
	pageId: string;
}

export interface GetPageInfoResp {
	pageId?: string;
	url?: string;
	/**
	 * @pattern ^\d+$
	 */
	pcCount?: string;
	/**
	 * @pattern ^\d+$
	 */
	mCount?: string;
	valid?: boolean;
}

export interface ModuleEventReq {
	moduleId?: string;
}

export interface ModuleEventResp {
	result?: PageResult;
}

export interface GetHomePagePlayGroundReq {

}

export interface GetHomePagePlayGroundResp {
	modules?: TFrontModule[];
	page?: PageTPlayground;
}

export interface GetHomeFrontModulesByTypeReq {
	types?: PageTModuleType[];
}

export interface GetHomeFrontModulesByTypeResp {
	moduleGroups?: {[key: string]: TModuleGroup};
}



export function GetFrontPlayground(payload: Partial<GetFrontPlaygroundReq>, options?: any) {
	return webapi<GetFrontPlaygroundResp>("page.App/GetFrontPlayground", payload, options);
}

export function GetFrontModules(payload: Partial<GetFrontModulesReq>, options?: any) {
	return webapi<GetFrontModulesResp>("page.App/GetFrontModules", payload, options);
}

export function GetFrontModulesBySlugAndType(payload: Partial<GetFrontModulesBySlugAndTypeReq>, options?: any) {
	return webapi<GetFrontModulesBySlugAndTypeResp>("page.App/GetFrontModulesBySlugAndType", payload, options);
}

export function GetProducts(payload: Partial<GetProductsReq>, options?: any) {
	return webapi<GetProductsResp>("page.App/GetProducts", payload, options);
}

export function GetSeoInfo(payload: Partial<GetSeoInfoReq>, options?: any) {
	return webapi<GetSeoInfoResp>("page.App/GetSeoInfo", payload, options);
}

export function GetFlashProducts(payload: Partial<GetFlashProductsReq>, options?: any) {
	return webapi<GetFlashProductsResp>("page.App/GetFlashProducts", payload, options);
}

export function GetPageInfo(payload: Partial<GetPageInfoReq>, options?: any) {
	return webapi<GetPageInfoResp>("page.App/GetPageInfo", payload, options);
}

export function ModuleEvent(payload: Partial<ModuleEventReq>, options?: any) {
	return webapi<ModuleEventResp>("page.App/ModuleEvent", payload, options);
}

export function GetHomePagePlayGround(payload: Partial<GetHomePagePlayGroundReq>, options?: any) {
	return webapi<GetHomePagePlayGroundResp>("page.App/GetHomePagePlayGround", payload, options);
}

export function GetHomeFrontModulesByType(payload: Partial<GetHomeFrontModulesByTypeReq>, options?: any) {
	return webapi<GetHomeFrontModulesByTypeResp>("page.App/GetHomeFrontModulesByType", payload, options);
}


export default {
	GetFrontPlayground,
	GetFrontModules,
	GetFrontModulesBySlugAndType,
	GetProducts,
	GetSeoInfo,
	GetFlashProducts,
	GetPageInfo,
	ModuleEvent,
	GetHomePagePlayGround,
	GetHomeFrontModulesByType,
};